import { parse as parseISODuration } from 'iso8601-duration';
import { intervalToDuration } from 'date-fns';

/**
 * A function which formats duration. The output format is "[hours]h [minutes]m", e.g. "3h 38m".
 * It currently doesn't support localization as it is not supported by any JavaScript
 * library and no one localizes it in Kiwi.
 *
 * @param seconds - number of seconds to be formatted.
 * @param durationISO - a ISO-8601 duration string or the number of seconds to be formatted.
 *
 * @returns string - formatted duration
 */
export default function formatDuration(seconds: number): string;
export default function formatDuration(durationISO: string): string; // eslint-disable-line @typescript-eslint/unified-signatures
export default function formatDuration(secondsOrDurationISO: string | number): string {
  const duration =
    typeof secondsOrDurationISO === 'number'
      ? intervalToDuration({ start: 0, end: secondsOrDurationISO * 1000 })
      : parseISODuration(secondsOrDurationISO);

  const arr = [
    duration.days ? `${duration.days}d` : '',
    duration.hours ? `${duration.hours}h` : '',
    duration.minutes ? `${duration.minutes}m` : '',
    duration.seconds ? `${duration.seconds}s` : '',
  ];

  // Filter durations to remove spaces at the start or end of the string in case of zero values.
  return arr.filter(Boolean).join(' ');
}
